import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'action-group, [action-group], [actionGroup], mir-action-group, [mir-action-group], [mirActionGroup]',
    standalone: false
})
export class ActionGroupDirective {

  @HostBinding('class')
  get hostCssClass(): string {
    return `mir-action-group action-group`;
  }

}
